import { render, staticRenderFns } from "./MedicalIncidents.vue?vue&type=template&id=09875b8c&scoped=true&"
import script from "./MedicalIncidents.vue?vue&type=script&lang=js&"
export * from "./MedicalIncidents.vue?vue&type=script&lang=js&"
import style0 from "./MedicalIncidents.vue?vue&type=style&index=0&id=09875b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09875b8c",
  null
  
)

export default component.exports